import {connect} from 'react-redux';
import {AdPreview} from 'VideoAudioQC/AccuratePlayer/AccuratePlayerTypes';
import {SetAdOnPlayingFrame, setAdOnPlayingFrameAction} from 'VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerActions';
import {AdBreaksState} from 'VideoAudioQC/Timeline/AdBreaks/Redux/AdBreaksReducer';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {AccuratePlayerState} from '../AccuratePlayer/Redux/AccuratePlayerReducer';
import AdOnPlayingFrameContainer from './AdOnPlayingFrameContainer';

interface StateProps {
    adBreaks: TimelineMarker[];
    adPreviews?: AdPreview[];
    adOnPlayingFrame?: TimelineMarker;
    currentTime: number;
    paused: boolean;
}

export interface PlayerState {
    videoAudioQC: {
        accuratePlayer: AccuratePlayerState;
    },
    timeline: {
        adBreaks: AdBreaksState,
    },
}

export const mapState = (state: PlayerState): StateProps => {
    const {
        videoAudioQC,
        timeline,
    } = state;
    const {accuratePlayer} = videoAudioQC;
    const {
        adPreviews,
        adOnPlayingFrame,
        currentTime,
        paused,
    } = accuratePlayer;
    const {adBreaks} = timeline;
    const {markers} = adBreaks;
    
    return {
        adBreaks: markers,
        adPreviews,
        adOnPlayingFrame,
        currentTime,
        paused,
    };
};

interface DispatchProps {
    setAdOnPlayingFrame: SetAdOnPlayingFrame;
}

export const mapDispatch: DispatchProps = {
    setAdOnPlayingFrame: setAdOnPlayingFrameAction,
};

export default connect(mapState, mapDispatch)(AdOnPlayingFrameContainer);
